// extracted by mini-css-extract-plugin
export default {"root":"XEXx40zHIW6kDqo_nSbI"};